import { TissueInformationFormProps } from "..";
import { TextFit } from "../../../../component-library";
import { useTIFFormData } from "../../../../hooks";
import { TissueTypes } from "../../../../models";
import { TIFDonorInfoLong, TIFDonorInfoShort } from ".";

export function TIFDonorInfo({ tissueId }: Readonly<TissueInformationFormProps>) {
    const { tissue } = useTIFFormData({ tissueId });

    const useShortForTissues: string[] = [
        TissueTypes.Cornea,
        TissueTypes.Cornea1,
        TissueTypes.Cornea2,
        TissueTypes.CorneaFrill,
        TissueTypes.WholeGlobe,
        TissueTypes.Quarter1,
        TissueTypes.Quarter2,
        TissueTypes.Quarter3,
        TissueTypes.Quarter4,
        TissueTypes.Sclera,
        TissueTypes.Sclera1,
        TissueTypes.Sclera2,
    ];

    const content = useShortForTissues.includes(tissue?.tissueType?.name ?? "") ? (
        <TIFDonorInfoShort tissueId={tissueId} />
    ) : (
        <TIFDonorInfoLong tissueId={tissueId} />
    );

    return (
        <>
            <TextFit style={{ width: "100%", maxHeight: "130px" }} maxFontSizePx={14}>
                {content}
            </TextFit>
            <hr className="my-1" />
        </>
    );
}
